import { render, staticRenderFns } from "./houseDetail.vue?vue&type=template&id=28664076&scoped=true"
import script from "./houseDetail.vue?vue&type=script&lang=js"
export * from "./houseDetail.vue?vue&type=script&lang=js"
import style0 from "./houseDetail.vue?vue&type=style&index=0&id=28664076&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28664076",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/jenkins_home/workspace/sihong_test_front_mall/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('28664076')) {
      api.createRecord('28664076', component.options)
    } else {
      api.reload('28664076', component.options)
    }
    module.hot.accept("./houseDetail.vue?vue&type=template&id=28664076&scoped=true", function () {
      api.rerender('28664076', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/wareHouse/houseDetail.vue"
export default component.exports